module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/DENTISTRY-25875c02e9a4a9e24de5a43ac10e8796.png";